import { IProduct } from "src/core/products/api/products.api";
import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "src/core/shared/api/config.api";
import useAxios from "src/core/shared/hooks/useAxios";
import {
  FilterParams,
  PaginatedData,
  PaginatedParams
} from "src/library/utils";

export type ListApprovalListParams = { pagination: PaginatedParams<IProductApprovalList>; filters?: FilterParams<IProductApprovalList> };
export type GetApprovalListProductsParams = { productApprovalListId: number; startDate: string };

export interface IProductApprovalList {
  id: number;
  name: string;
  description?: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface IProductApprovalItem {
  id: number;
  productApprovalListId: number;
  productId: number;
  product?: IProduct;
  startDate: string;
  endDate: string | null;
}

export enum ProductApprovalRequestName {
  LIST_APPROVAL_LISTS = "LIST_APPROVAL_LISTS",
  GET_APPROVAL_LIST = "GET_APPROVAL_LIST",
  GET_APPROVAL_CHANGE_DATES = "GET_APPROVAL_CHANGE_DATES",
  GET_APPROVAL_LIST_PRODUCTS = "GET_APPROVAL_LIST_PRODUCTS",
  EXPORT_APPROVAL_LISTS = "EXPORT_APPROVAL_LISTS"
}

type ProductApprovalEndpointConfig = {
  [ProductApprovalRequestName.LIST_APPROVAL_LISTS]: EndpointConfig<
    ListApprovalListParams,
    PaginatedData<IProductApprovalList>
  >,
  [ProductApprovalRequestName.GET_APPROVAL_LIST]: EndpointConfig<
    {id: number},
    IProductApprovalList
  >,
  [ProductApprovalRequestName.GET_APPROVAL_CHANGE_DATES]: EndpointConfig<
    {productApprovalListId: number},
    IProductApprovalItem[]
  >,
  [ProductApprovalRequestName.GET_APPROVAL_LIST_PRODUCTS]: EndpointConfig<
    GetApprovalListProductsParams,
    IProductApprovalItem[]
  >,
  [ProductApprovalRequestName.EXPORT_APPROVAL_LISTS]: EndpointConfig<
  {productApprovalListId: number | null;},
  {message: string;}
>
};

const BASE_URL = `${process.env.REACT_APP_API_URL}/product-approval/approval-lists`;

/**
 * product approval API
 */
const requests: RequestConfig<ProductApprovalEndpointConfig> = {
  [ ProductApprovalRequestName.LIST_APPROVAL_LISTS ]: ({ ...params }) => ({
    url: `${BASE_URL}`,
    method: "GET",
    params
  }),
  [ ProductApprovalRequestName.GET_APPROVAL_LIST ]: ({ id }) => ({
    url: `${BASE_URL}/${id}`,
    method: "GET"
  }),
  [ ProductApprovalRequestName.GET_APPROVAL_CHANGE_DATES ]: ({ productApprovalListId }) => ({
    url: `${BASE_URL}/${productApprovalListId}/change-dates`,
    method: "GET"
  }),
  [ ProductApprovalRequestName.GET_APPROVAL_LIST_PRODUCTS ]: ({ productApprovalListId, startDate }) => ({
    url: `${BASE_URL}/${productApprovalListId}/products/${startDate}`,
    method: "GET"
  }),
  [ ProductApprovalRequestName.EXPORT_APPROVAL_LISTS ]: ({ productApprovalListId }) => ({
    url: `${BASE_URL}/${productApprovalListId}/export`,
    method: "GET"
  })
};

export const useProductApprovalApi: UseApiRequest<ProductApprovalEndpointConfig> = name => useAxios(requests[ name ], name);
